export type PlayProps = {
  className?: string;
  unsize?: boolean;
};

export function Play(props: PlayProps) {
  return (
    <svg
      width={props.unsize ? undefined : "38"}
      height={props.unsize ? undefined : "38"}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20 0C16.0444 0 12.1776 1.17298 8.8886 3.37061C5.59962 5.56823 3.03617 8.69181 1.52242 12.3463C0.00866572 16.0008 -0.387401 20.0222 0.384303 23.9018C1.15601 27.7814 3.06082 31.3451 5.85787 34.1421C8.65492 36.9392 12.2186 38.844 16.0982 39.6157C19.9778 40.3874 23.9991 39.9913 27.6537 38.4776C31.3082 36.9638 34.4318 34.4004 36.6294 31.1114C38.827 27.8224 40 23.9556 40 20C39.9955 14.697 37.887 9.61255 34.1372 5.86279C30.3875 2.11303 25.303 0.00446002 20 0ZM26.4421 21.0105L17.0105 27.2842C16.8274 27.4071 16.6143 27.4778 16.394 27.489C16.1737 27.5001 15.9546 27.4511 15.76 27.3474C15.5654 27.2436 15.4027 27.0889 15.2892 26.8997C15.1757 26.7106 15.1158 26.4942 15.1158 26.2737V13.7263C15.1158 13.5058 15.1757 13.2894 15.2892 13.1003C15.4027 12.9111 15.5654 12.7564 15.76 12.6526C15.9546 12.5488 16.1737 12.4999 16.394 12.511C16.6143 12.5221 16.8274 12.5929 17.0105 12.7158L26.4421 18.9895C26.6071 19.1014 26.7422 19.252 26.8356 19.4281C26.9289 19.6043 26.9777 19.8006 26.9777 20C26.9777 20.1994 26.9289 20.3957 26.8356 20.5718C26.7422 20.748 26.6071 20.8986 26.4421 21.0105Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default Play;
